import type * as Immutable from 'immutable';
import { createMigration } from './utils';

function migrateGraphic(map: Immutable.Map<string, unknown>, path: (string | number)[]) {
    const graphic = map.getIn(path) as Immutable.Map<string, unknown> | undefined;
    const shape = graphic?.get('shape') as Immutable.Map<string, unknown> | undefined;
    if (
        graphic &&
        graphic.has('graphic') &&
        graphic.get('graphic') === 'box' &&
        graphic.has('shape') &&
        shape?.get('boxHeight') === 'height (without descent)'
    ) {
        map.setIn([...path, 'shape', 'boxHeight'], 'height');
    }
}

function migrateAsset(someParentNode: Immutable.Map<string, unknown>, path: (string | number)[]) {
    const asset = someParentNode.getIn(path) as Immutable.Map<string, unknown> | undefined;
    if (asset && asset.has('colorGraphics')) {
        const graphics = (asset.get('colorGraphics') as Immutable.List<unknown>) || [];
        graphics.forEach((_, ind) => {
            migrateGraphic(someParentNode, [...path, 'colorGraphics', ind]);
        });
    }
}

function migrateSceneGroup(sceneGroup: Immutable.Map<string, unknown>) {
    return sceneGroup.withMutations((map) => {
        if (map.has('mediaAsset')) {
            migrateAsset(map, ['mediaAsset']);
        }
    });
}

export const migrationTo9_237 = createMigration({
    migrateVideo(video) {
        return video.withMutations((map) => {
            map.get('sceneGroups').forEach((sceneGroup, i) => {
                map.setIn(['sceneGroups', i], migrateSceneGroup(sceneGroup));
            });
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations((map) => {
            if (map.has('children')) {
                const children = map.get('children') as Immutable.List<unknown>;
                children.forEach((_, i) => {
                    migrateAsset(map, ['children', i]);
                });
            }
            if (map.has('stickers')) {
                const stickers = map.get('stickers') as Immutable.List<unknown>;
                stickers.forEach((_, i) => {
                    migrateAsset(map, ['stickers', i]);
                });
            }
            if (map.has('subslides')) {
                const subslides = map.get('subslides') as Immutable.List<unknown>;
                subslides.forEach((subslide: Immutable.Map<string, unknown>, i) => {
                    if (subslide.has('children')) {
                        const children = subslide.get('children') as Immutable.List<unknown>;
                        children.forEach((_, j) => {
                            migrateAsset(map, ['subslides', i, 'children', j]);
                        });
                    }
                });
            }
        });
    },
});
